<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="public" />
        

    </div>
</div>
<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <div class="link-to-home"><p><a tabindex="100" (click)="onHome()" title="{{ 'bss.help.home.link.title' | translate }}">
            {{'bss.help.home.link' | translate }}
          </a> > {{'bss.help.home.toHelp' | translate}}</p></div>
        <h2 id="pageTitle" tabindex="100" aria-live="polite">{{'bss.help.title'| translate}}</h2>
        <hr>
        <p>
            {{'bss.help.subTitle' |translate}}
        </p>
        <hr>
        <ng-container *ngFor="let section of accordionSections; let i = index">
            <div class="ontario-small-12 ">

                <h3>{{ section.title | translate}}</h3>
                <div class="ontario-column ontario-margin-bottom">
                    <div class='ontario-accordions__container'>
                        <div class="ontario-row">
                            <div class='ontario-accordion__controls'>
                                <button tabindex = "100 + i*12" class='ontario-accordion__button--expand-all' [attr.aria-label]="buttonText(i)" [attr.aria-expanded]= "isAllExpanded(i)"
                                    (click)="expandAll(i)">
                                    <span *ngIf="!isAllExpanded(i)" aria-hidden = "true" title="{{'bss.help.expand.title'|translate}}"
                                        class='ontario-accordion--expand-open-all'>{{'bss.help.expand'|translate}}</span>
                                    <span *ngIf="isAllExpanded(i)" aria-hidden = "true" title="{{'bss.help.collapse.title'|translate}}">{{'bss.help.collapse'|translate}}</span>
                                </button>
                            </div>
                        </div>
                        <div class="ontario-row ">
                            <ng-container *ngFor="let item of section.items; let j = index">
                                <div class="ontario-accordion" [id]="'accordion-' + i + '-' + j">
                                    <h3 class="ontario-accordion-heading">
                                        <button tabindex = "100+ i*12 +j" class="ontario-accordion__button"
                                            [id]="'accordion-button-id-' + i  + '-' + j" [title]="isContentVisible[i][j] ? ('bss.help.select.toCollapse' | translate) + ' ' + (item.title|translate) : ('bss.help.select.toExpand'| translate) + ' ' + (item.title|translate)"
                                            [attr.aria-controls]="'accordion-content-' + i  + '-' + j"
                                                [attr.aria-expanded]="isContentVisible[i][j] ? 'true' : 'false'" 
                                            (click)="toggleContent(i,j)" data-toggle="ontario-collapse" aria-describedby="'accordion-content-' + i + '-' + j">
                                            <span class="ontario-accordion__button-icon--close"
                                                [style.display]="isContentVisible[i][j] ? 'block' : 'none'">
                                                <img src="assets/icons/svg/ontario-icon-chevron-up.svg"
                                                    class="ontario-icon" aria-hidden="true" alt="" focusable="false"
                                                    sol:category="primary" viewBox="0 0 24 24"
                                                    preserveAspectRatio="xMidYMid meet">
                                            </span>
                                            <span class="ontario-accordion__button-icon--open"
                                                [style.display]="isContentVisible[i][j] ? 'none' : 'block'">
                                                <img src="assets/icons/svg/ontario-icon-chevron-down.svg"
                                                    class="ontario-icon" alt="" aria-hidden="true" focusable="false"
                                                    sol:category="primary" viewBox="0 0 24 24"
                                                    preserveAspectRatio="xMidYMid meet">
                                            </span>
                                            {{ item.title | translate}}
                                        </button>
                                    </h3>
                                    <section class="ontario-accordion__content"
                                        [id]="'accordion-content-' + i + '-' + j"
                                        [style.display]="isContentVisible[i][j] ? 'block' : 'none'"
                                        [attr.aria-labelledby]="'accordion-button-id-' + i + '-' + j" aria-live="polite" aria-atomic="true"
                                        data-toggle="ontario-expander-content" [innerHTML]="item.content | translate">

                                    </section>
                                </div>
                            </ng-container>



                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>